import type { UnityInstance } from "./unity";

export type ShellPauseReason = "modal" | "application_background" | "loading" | "error";

export interface ShellPauseState {
  reason: ShellPauseReason;
  active: boolean;
}

export function publishShellPause(
  instance: UnityInstance | undefined,
  reason: ShellPauseReason,
  active: boolean,
): boolean {
  if (!instance?.SendMessage) return false;
  const state: ShellPauseState = { reason, active };
  instance.SendMessage("SuperWerwolfSession", "SetShellPauseState", JSON.stringify(state));
  return true;
}

export function restoreCanvasFocus(canvas: HTMLCanvasElement): void {
  window.requestAnimationFrame(() => canvas.focus({ preventScroll: true }));
}
